import React, { Component } from 'react';
import PropTypes from 'prop-types';

import KeyIngredient from './KeyIngredient';

import Image from '../../components/ContentfulImage';

import {
  Section,
  Title,
  KeyIngredientsContainer,
  KeyIngredientsImages,
  KeyIngredientsImage,
  KeyIngredientsText,
  Pseudo,
} from './ProductIngredients.style';
import Placeholder from '../Placeholder';

const positions = [
  { left: '40%', top: '20%' },
  { left: '70%', top: '40%' },
  { left: '30%', top: '60%' },
  { left: '60%', top: '80%' },
];

class ProductIngredients extends Component {
  toggleShowMore = () => {
    this.setState(state => ({ showMore: !state.showMore }));
  };

  render() {
    const { copy, keyIngredients } = this.props;

    return (
      <Section>
        <Title>{copy.key_ingredients || <Placeholder w="150px" h="20px" />}</Title>

        <KeyIngredientsContainer>
          <KeyIngredientsImages>
            {keyIngredients.filter(item => item.image || item.key).map((ingredient, i) => (
              <KeyIngredientsImage key={ingredient.name || ingredient.key} {...positions[i]}>
                {ingredient.image ? (
                  <Image src={ingredient.image} options={{ size: 200, objectFit: 'cover', h: '100%', w: '100%' }} />
                ) : (
                  <Placeholder key={ingredient.key} h="100%" w="100%" />
                )}
              </KeyIngredientsImage>
            ))}
            <Pseudo />
          </KeyIngredientsImages>

          <KeyIngredientsText>
            {keyIngredients.map(ingredient => <KeyIngredient key={ingredient.name} {...ingredient} />)}
          </KeyIngredientsText>
        </KeyIngredientsContainer>
      </Section>
    );
  }
}

ProductIngredients.defaultProps = {
  copy: {},
};

ProductIngredients.propTypes = {
  keyIngredients: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  copy: PropTypes.shape(),
};

export default ProductIngredients;



// WEBPACK FOOTER //
// ./src/components/ProductIngredients/ProductIngredients.js